function isTokenValid(name: 'refreshToken' | 'accessToken'): boolean {
  const token = localStorage.getItem(name);
  if (!token) return false;

  try {
    const payload = token.split('.')[1];
    if (!payload) return false;

    const decodedPayload = atob(payload);
    const decoded = JSON.parse(decodedPayload);
    if ((decoded.exp * 1000) < Date.now()) return false;
    return true;
  } catch (error) {
    console.error('Failed to parse token payload', error);
    return false;
  }
}

export const accountUtils = {
  isAccessTokenExpired() {
    return !isTokenValid('accessToken');
  },
  isLogin() {
    return isTokenValid('refreshToken');
  }
};